import { ageGroups, platforms, purchaseModels } from '../../utils/defaultsProvider';

class ClientFormController {
    /**
     * @param $q
     * @param $anchorScroll
     * @param $location
     * @param $stateParams
     * @param $mdDialog
     * @param Upload
     * @param EvaluationService
     * @param $state
     * @param stateConstants
     */
    constructor(
        $q,
        $anchorScroll,
        $location,
        $stateParams,
        $mdDialog,
        Upload,
        commonDataService,
        evaluationService,
        $state,
        stateConstants,
    ) {
        this.basic = {};
        this.allAgeGroups = ageGroups;
        this.allPlatforms = platforms;
        this.allPurchaseModels = purchaseModels;
        this.basic.ageGroups = [];
        this.basic.platforms = [];
        this.basic.languages = [];
        this.basic.offlinePlayText = true;
        this.basic.noRegistrationText = true;
        this.basic.catalogueCoverIcon = '';
        this.basic.videoLinks = [];
        this.basic.purchaseModels = [];
        this.basic.smallImageObject = '';
        this.basic.mediumImageObject = '';
        this.basic.largeImageObject = '';
        this.basic.relevantCurriculum = null;
        this.basic.publishImages = {
            items: [],
        };
        this.ageGroupsInvalid = false;
        this.curriculums = [];
        this.uploadError = {};
        this.newImage = {};
        this.$mdDialog = $mdDialog;
        this.$anchorScroll = $anchorScroll;
        this.$location = $location;
        this.$q = $q;
        this.$state = $state;
        this.stateConstants = stateConstants;
        this.Upload = Upload;
        this.commonDataService = commonDataService;
        this.evaluationService = evaluationService;
        this.showForm = false;

        this.secret = $stateParams.secret;
    }

    $onInit() {
        this.checkIfSecretExists(this.secret);
    }

    checkIfSecretExists(secret) {
        this.evaluationService.checkIfSecretExists(secret).then((data) => {
            this.basic = data;
            this.showForm = true;
        }).catch((err) => {
            this.$mdDialog.show(
                this.$mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title('The link is not valid. If you want to fill the form again - contact Kokoa')
                    .ok('OK'),
            );
            console.error('ERROR', err);
        });
    }

    anyImageUploaded() {
        return (this.basic.smallImageObject !== '') ||
            (this.basic.mediumImageObject !== '') ||
            (this.basic.largeImageObject !== '');
    }

    uploadImage() {
        if (this.basic.publishImages.items.length >= 5) {
            return;
        }
        this.uploadError.publishImages = null;
        if (this.newImage && this.newImage.size > 3000000) {
            this.uploadError.publishImages = 'TOO_LARGE';
            return;
        }
        this.evaluationService.uploadPublishImage(this.newImage)
            .then((e) => {
                this.basic.publishImages.items.push({
                    link: e.data.path,
                    subtitle: '',
                    published: true,
                });
            })
            .catch(err => console.error(err));
    }

    addVideoLink() {
        if (this.basic.videoLinks.length < 4) {
            this.basic.videoLinks.push({ link: '' });
        }
    }

    search(entity, term) {
        return this.commonDataService.search(entity, term).then((res) => res.data);
    }

    sendForm($form, data) {
        this.$anchorScroll.yOffset = 100;
        if (!$form.$invalid) {
            this.proceedForm(data);
        } else {
            this.$mdDialog.show(
                this.$mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title('Please fill the required fields on the form before sending!')
                    .ok('OK'),
            ).finally(() => {
                $form.$setSubmitted();
                angular.element(document.querySelector('input.ng-invalid-required')).focus();
            });
        }
    }

    onPictureUpload(fileEntity, obj, field, isList = false) {
        if (isList) {
            fileEntity.forEach((file) => {
                this.evaluationService.convertImageToBase64(file)
                    .then((res) => {
                        if (res) {
                            this.uploadError[field] = null;
                            (obj[field]).push({
                                link: res.replace(/^.+base64,/, ''),
                                subtitle: '',
                                published: false,
                            });
                        }
                    })
                    .catch((error) => {
                        this.uploadError[field] = error.status;
                    });
            });
        } else {
            this.evaluationService.convertImageToBase64(fileEntity)
                .then((res) => {
                    if (res) {
                        this.uploadError[field] = null;
                        obj[field] = res.replace(/^.+base64,/, '');
                    }
                })
                .catch((error) => {
                    this.uploadError[field] = error.status;
                });
        }
    }

    toggleListMember(item, list) {
        const idx = list.indexOf(item);
        if (idx > -1) {
            list.splice(idx, 1);
        } else {
            list.push(item);
        }
    }

    isOnList(item, list) {
        if (list && !list.length) {
            list = [];
        }
        return list.indexOf(item) > -1;
    }

    /**
     * @param {Object} data
     */
    proceedForm(data) {
        this.basic.isOfflinePlay = this.basic.isOfflinePlay === true;
        this.basic.isNoRegistration = this.basic.isNoRegistration === true;
        this.evaluationService.saveCustomerForm(data, this.secret).then((data) => {
            this.showForm = false;
            this.$state.go(this.stateConstants.CLIENT_CONFIRMED);
            this.$anchorScroll.yOffset = 0;
            this.$anchorScroll('top');
        }).catch((err) => {
            this.$mdDialog.show(
                this.$mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title('Some mandatory fields are not were not checked')
                    .ok('OK'),
            );
        });
    }

    openExamplePopup(background) {
        this.$mdDialog.show({
            clickOutsideToClose: true,
            template: `
            <md-dialog class="md-dialog--borderless">
                <div style="overflow: hidden; position: relative;">
                    <img style="width: 100%" src="/api/assets/customer_form_images/${background}">
                    <img ng-click="closeDialog()" style="position: absolute; right: 10px; top: 10px; max-width: 15%; cursor: pointer;" src="/api/assets/customer_form_images/close.png">
                </div>
            </md-dialog>
            
          `,
            controller: ($scope, $mdDialog) => {
                $scope.closeDialog = () => $mdDialog.hide();
            },
            autoWrap: false,
        });
    }
}

ClientFormController.$inject = [
    '$q',
    '$anchorScroll',
    '$location',
    '$stateParams',
    '$mdDialog',
    'Upload',
    'CommonDataService',
    'EvaluationService',
    '$state',
    'stateConstants',
];

export default ClientFormController;



// WEBPACK FOOTER //
// ./src/app/pages/clientForm/clientFormController.js